import React from 'react';
import RequestPanelNarrowContent from './RequestPanelNarrowContent';
import RequestPanelContainer from './RequestPanelContainer';
import Selectors from '../hooks/selectors';

const RequestPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const { requestCode, requestUrl, isNew } = Selectors.useRequestPanel({ category, code, url });
  return (
    <RequestPanelContainer
      category={category}
      className="aridhia-request-panel-narrow overflow-x-hidden panel-wizardible"
      code={requestCode}
      compact
      isNew={isNew}
      onChange={onChange}
      url={requestUrl}
    >
      <RequestPanelNarrowContent category={category} code={requestCode} />
    </RequestPanelContainer>
  );
};

export default RequestPanelNarrow;
